(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promo-code"] && !Shopify.designMode) return;
  try {
    (function () {
    function copier(texte) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(texte);
      }
      return new Promise(function (resoudre, rejeter) {
        var zone = document.createElement('textarea');
        zone.value = texte;
        zone.setAttribute('readonly', '');
        zone.style.cssText = 'position:fixed;top:-9999px;opacity:0';
        document.body.appendChild(zone);
        zone.select();
        try {
          document.execCommand('copy') ? resoudre() : rejeter();
        } catch (e) {
          rejeter(e);
        } finally {
          document.body.removeChild(zone);
        }
      });
    }
    document.addEventListener('click', function (evenement) {
      var bouton = evenement.target.closest('.pr-promo__code');
      if (!bouton || bouton.classList.contains('est-copie')) return;
      var fini = function () {
        bouton.classList.add('est-copie');
        setTimeout(function () { bouton.classList.remove('est-copie'); }, 1600);
      };
      copier(bouton.dataset.code).then(fini, fini);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
